import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-530d23f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "import-request-access" }
const _hoisted_2 = { class: "qr-wrapper is-flex is-justify-content-center is-align-items-center mx-auto p-4" }
const _hoisted_3 = { class: "steps px-6 pt-6" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "info mt-4 px-4" }
const _hoisted_6 = { class: "buttons" }

import { useRoute, useRouter } from 'vue-router'
import { ERC725YDataKeys } from '@lukso/lsp-smart-contracts'
import { onMounted, ref } from 'vue'

import QRCodeShow from '@/popup/components/shared/QRCode/QRCodeShow.vue'
import ImportWizard from '@/popup/components/shared/Wizard.vue'
import Button from '@/popup/components/shared/Button.vue'
import { constructURLToAddController } from '@/popup/utils/ethUrlUtils'
import { PopupDatabase } from '@/popup/storage/Database'
import { getDataABI } from '@/shared/abis/getDataABI'
import { useAppStore } from '@/popup/store/AppStore'
import { useWeb3Eth } from '@/popup/compositions/useWeb3Eth'
import { assertNotUndefined } from '@/shared/validators'
import { hexToAssertNumber } from '@/shared/utils'

type Emits = {
  (event: 'import-cancel', routeTo: string): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ImportRequestAccess',
  emits: ["import-cancel"],
  setup(__props, { emit: __emit }) {

const emits = __emit

const appStore = useAppStore()
const { createContract } = useWeb3Eth()
const router = useRouter()
const route = useRoute()
const chainId = appStore.network.chainId
const qrCodeUrl = ref<string>()

const onCancel = () => {
  emits('import-cancel', '/qrcode/import-scan')
}

const onConfirm = () => {
  router.push({
    path: '/qrcode/import-waiting',
    query: { address: route.query['address'] },
  })
}

onMounted(async () => {
  try {
    assertNotUndefined(
      appStore.selectedProfile,
      'Selected profile not found while mounting ImportRequestAccess'
    )
    const profile = await PopupDatabase.getProfile(appStore.selectedProfile)
    assertNotUndefined(
      profile,
      'Profile not found while mounting ImportRequestAccess'
    )
    const [length] = Object.values(ERC725YDataKeys.LSP6['AddressPermissions[]'])
    const lengthValue = await createContract(
      getDataABI,
      appStore.selectedProfile
    )
      .methods['getData(bytes32)'](length)
      .call()
    const lengthParsed = Number(hexToAssertNumber(lengthValue))
    qrCodeUrl.value = constructURLToAddController(
      appStore.selectedProfile,
      chainId,
      lengthParsed,
      profile?.controllerAddress
    )
  } catch {
    emits('import-cancel', '/qrcode/import-scan')
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ImportWizard, {
      title: _ctx.$t('import_wizard.request_access'),
      progress: 60
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      (qrCodeUrl.value)
        ? (_openBlock(), _createBlock(QRCodeShow, {
            key: 0,
            size: 199,
            value: qrCodeUrl.value,
            "data-testid": "qrcode=show"
          }, null, 8 /* PROPS */, ["value"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('import_request_access.steps')), 1 /* TEXT */),
      _createElementVNode("ol", _hoisted_5, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('import_request_access.step1')), 1 /* TEXT */),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('import_request_access.step2')), 1 /* TEXT */),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('import_request_access.step3')), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(Button, {
        variant: "text",
        "is-full-width": true,
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('import_request_access.cancel')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(Button, {
        variant: "primary",
        "is-full-width": true,
        onClick: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('import_request_access.confirm')), 1 /* TEXT */)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}
}

})